import { FOR_YOU_CATEGORY_ID, PROMPT_CARDS_PER_TAB, PROMPT_CATEGORIES } from './promptLibrary';

export const AI_PROMPT_SUGGESTIONS_PREFIX = 'STATIC.PAGES.ANALYSIS_CHAT.EMPTY_STATE.SUGGESTIONS';

export const PROMPT_SUGGESTIONS_URL = 'interactive-service/prompt-suggestions';

export const DEFAULT_SUGGESTION_ICON = 'sparkles';

export const STATIC_SUGGESTIONS = [
    { id: 'COMPARE_PERFORMANCE', icon: 'chart-bar' },
    { id: 'SUMMARIZE_ACTIVITY', icon: 'file-text' },
    { id: 'EXPLAIN_DECREASE', icon: 'chart-line' },
    { id: 'SET_UP_POSTBACKS', icon: 'settings' },
];

export const STATIC_SUGGESTION_IDS = STATIC_SUGGESTIONS.map(({ id }) => id);

const CHIP_PATTERN = /\{([^{}]*)\}/;

export const parsePromptText = text => {
    const match = CHIP_PATTERN.exec(text);
    if (!match) return { pre: text, chip: '', post: '' };

    return { pre: text.slice(0, match.index), chip: match[1], post: text.slice(match.index + match[0].length) };
};

const normalizePrompt = promptText => {
    const { pre, chip, post } = parsePromptText(promptText);

    return { pre, chip, post, text: pre + chip + post };
};

const personalizedCardId = (icon, index) => `${icon}-${index + 1}`;

export const buildPersonalizedCards = personalized =>
    (personalized || []).slice(0, PROMPT_CARDS_PER_TAB).map(({ text, label, tag, icon }, index) => {
        const prompt = normalizePrompt(text);

        return {
            id: personalizedCardId(icon, index),
            icon,
            label: label || prompt.text,
            tag: tag || '',
            ...prompt,
            isPersonalized: true,
        };
    });

export const buildSuggestions = (personalized, translate) => {
    if (personalized?.length) {
        return buildPersonalizedCards(personalized).map(({ id, text, icon, isPersonalized }) => ({
            id,
            text,
            icon,
            isPersonalized,
        }));
    }

    return STATIC_SUGGESTIONS.map(({ id, icon }) => ({
        id,
        icon,
        text: translate(`${AI_PROMPT_SUGGESTIONS_PREFIX}.${id}`),
        isPersonalized: false,
    }));
};

const categoryPromptKey = (categoryId, promptId) =>
    `${AI_PROMPT_SUGGESTIONS_PREFIX}.CATEGORIES.${categoryId}.PROMPTS.${promptId}`;

export const buildCategoryCards = (categoryId, translate) => {
    const category = PROMPT_CATEGORIES.find(({ id }) => id === categoryId);

    return (category?.prompts || []).map(({ id, icon }) => {
        const key = categoryPromptKey(categoryId, id);

        return {
            id: `${categoryId}.${id}`,
            icon,
            label: translate(`${key}.LABEL`),
            tag: translate(`${key}.TAG`),
            ...normalizePrompt(translate(`${key}.TEXT`)),
            isPersonalized: false,
        };
    });
};

export const buildCategoryChips = ({ hasPersonalized, translate }) => {
    const chips = PROMPT_CATEGORIES.map(({ id }) => ({
        id,
        label: translate(`${AI_PROMPT_SUGGESTIONS_PREFIX}.CATEGORIES.${id}.LABEL`),
    }));

    if (!hasPersonalized) return chips;

    return [{ id: FOR_YOU_CATEGORY_ID, label: translate(`${AI_PROMPT_SUGGESTIONS_PREFIX}.FOR_YOU`) }, ...chips];
};
